import { render, staticRenderFns } from "./SignageUpdates.vue?vue&type=template&id=4641a578&scoped=true&"
import script from "./SignageUpdates.vue?vue&type=script&lang=js&"
export * from "./SignageUpdates.vue?vue&type=script&lang=js&"
import style0 from "./SignageUpdates.vue?vue&type=style&index=0&id=4641a578&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4641a578",
  null
  
)

export default component.exports